import { instance } from '../app/instance';

/**
 * Get all promo codes with pagination and filters
 * GET /api/admin/promo
 */
export const getAllPromoCodes = async (params = {}) => {
  const response = await instance.get('/promo', { params });
  return response.data;
};

/**
 * Get promo code usage statistics
 * GET /api/admin/promo/stats/usage
 */
export const getPromoCodeUsageStats = async () => {
  const response = await instance.get('/promo/stats/usage');
  return response.data;
};

/**
 * Get promo code by ID
 * GET /api/admin/promo/:id
 */
export const getPromoCodeById = async (id) => {
  const response = await instance.get(`/promo/${id}`);
  return response.data;
};

/**
 * Create new promo code
 * POST /api/admin/promo
 */
export const createPromoCode = async (promoData) => {
  const response = await instance.post('/promo', promoData);
  return response.data;
};

/**
 * Update promo code
 * PATCH /api/admin/promo/:id
 */
export const updatePromoCode = async (id, updates) => {
  const response = await instance.patch(`/promo/${id}`, updates);
  return response.data;
};

/**
 * Delete promo code
 * DELETE /api/admin/promo/:id
 */
export const deletePromoCode = async (id) => {
  const response = await instance.delete(`/promo/${id}`);
  return response.data;
};

/**
 * Toggle promo code active status
 * PATCH /api/admin/promo/:id/toggle
 */
export const togglePromoCodeStatus = async (id) => {
  const response = await instance.patch(`/promo/${id}/toggle`);
  return response.data;
};

/**
 * Reset promo code usage count
 * PATCH /api/admin/promo/:id/reset-usage
 */
export const resetPromoCodeUsage = async (id) => {
  const response = await instance.patch(`/promo/${id}/reset-usage`);
  return response.data;
};
